import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable()
export class ChallengeService {

    private host: any = {};

    constructor(private client: HttpClient) {
        this.host['v2-challenges'] = environment.host('v2-challenges');
    }

    uploadNewChallenge(mini: File, file: File, name: String, start: String, end: String, target: number, type: String, orderBy: String, limit: number, details: any[]): Observable<any> {
        let data = {
            name: name,
            start: start,
            end: end,
            target: target,
            type: type,
            orderBy: orderBy,
            limit: limit,
            details: details.map(detail => ({ locale: detail.locale, detail: detail.detail }))
        };
        const formData: FormData = new FormData();
        formData.append('mini', mini, mini.name);
        formData.append('file', file, file.name);
        formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));
        return this.client.request('POST', `${this.host['v2-challenges']}/v2/challenges`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: formData
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('ChallengeService.uploadNewChallenge.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('ChallengeService.uploadNewChallenge.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    uploadNewChallengeLocale(challengeId: number, locale: String, detail: String): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-challenges']}/v2/challenges/${challengeId}/locale/${locale}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                detail: detail
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('ChallengeService.uploadNewChallengeLocale.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('ChallengeService.uploadNewChallengeLocale.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    deleteChallenge(challengeId: number): Observable<any> {
        return this.client.request('DELETE', `${this.host['v2-challenges']}/v2/challenges/${challengeId}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('ChallengeService.deleteChallenge.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('ChallengeService.deleteChallenge.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    deleteChallengeLocale(challengeId: number, locale: string): Observable<any> {
        return this.client.request('DELETE', `${this.host['v2-challenges']}/v2/challenges/${challengeId}/locale/${locale}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('ChallengeService.deleteChallengeLocale.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('ChallengeService.deleteChallengeLocale.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getChallenges(): Observable<any> {
        return this.client.request('GET', `${this.host['v2-challenges']}/v2/challenges/admin`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('ChallengeService.getChallenges.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('ChallengeService.getChallenges.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }
}
